import React, { useState, useEffect } from 'react';
import ExposureRadar from 'common/components/GenerateThreatsReport/pages/ExposureRadar/ExposureRadar';
import Highlights from 'common/components/GenerateThreatsReport/pages//Highlights/Highlights';
import LastPage from 'common/components/GenerateThreatsReport/pages/LastPage/LastPage';
import CoverPage from 'common/components/GenerateThreatsReport/pages/CoverPage/CoverPage';
import {
  ThreatsReportContextType,
  useThreatsReport
} from 'common/components/GenerateThreatsReport/ThreatsReportContext';
import { AppLoading } from 'common/components/appLoading/appLoading';
import Examples from 'common/components/GenerateThreatsReport/pages//Examples/Examples';

const ThreatsReport = () => {
  const { highlightsList, isLoading, PAGE_WIDTH } = useThreatsReport() as ThreatsReportContextType;
  const [runTimer, setRunTimer] = useState(false);

  useEffect(() => {
    if (runTimer) {
      const timer = setTimeout(() => {
        window.print();
        setRunTimer(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [runTimer]);

  useEffect(() => {
    if (!isLoading) {
      setRunTimer(true);
    }
  }, [isLoading]);

  return isLoading ? (
    <AppLoading />
  ) : (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: PAGE_WIDTH,
          backgroundColor: '#ffffff'
        }}
      >
        <CoverPage />
        <ExposureRadar />
        {!!highlightsList.length && <Highlights />}
        <Examples />
        <LastPage />
      </div>
    </div>
  );
};

export default ThreatsReport;
